//Angular imports
import { Injectable } from '@angular/core';

//3rd party imports
import { DeviceDetectorService, DeviceInfo } from 'ngx-device-detector';

@Injectable({
  providedIn: 'root'
})
export class DeviceService {
  private deviceInfo: DeviceInfo;

  constructor(private deviceDetectorService: DeviceDetectorService) {}

  public get deviceInfomation(): DeviceInfo {
    if (this.deviceInfo === undefined) {
      this.deviceInfo = this.deviceDetectorService.getDeviceInfo();
    }

    return this.deviceInfo;
  }
}
